import { getWindow } from 'ssr-window';

export const isCypress = () => getWindow().localStorage.getItem('cypress') === '1';
